import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {StatsClickEvent} from "../models/events/stats.click-event";

export class StatsClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.statsClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = StatsClickEvent;
  }
}
